import { supabase } from './supabaseClient'

export const AnalyticsEvents = {
  PROJECT_VIEW: 'project_view',
  PROJECT_FOLLOW: 'project_follow',
  PROJECT_UNFOLLOW: 'project_unfollow',
  UNIT_VIEW: 'unit_view',
  UNIT_RESERVE: 'unit_reserve',
  SEARCH: 'search',
  SIGN_UP: 'sign_up',
  SIGN_IN: 'sign_in',
  PAGE_VIEW: 'page_view',
}

let sessionId = null

function getSessionId() {
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  }
  return sessionId
}

export async function trackEvent(eventType, metadata = {}) {
  try {
    const { error } = await supabase.rpc('track_event', {
      p_event_type: eventType,
      p_project_id: metadata.projectId || null,
      p_unit_id: metadata.unitId || null,
      p_metadata: {
        ...metadata,
        sessionId: getSessionId(),
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href,
      },
    })

    if (error) {
      console.error('Analytics tracking error:', error)
    }
  } catch (error) {
    console.error('Analytics tracking error:', error)
  }
}

export function useAnalytics() {
  const trackProjectView = (projectId) => {
    trackEvent(AnalyticsEvents.PROJECT_VIEW, { projectId })
  }

  const trackProjectFollow = (projectId) => {
    trackEvent(AnalyticsEvents.PROJECT_FOLLOW, { projectId })
  }

  const trackProjectUnfollow = (projectId) => {
    trackEvent(AnalyticsEvents.PROJECT_UNFOLLOW, { projectId })
  }

  const trackUnitView = (unitId, projectId) => {
    trackEvent(AnalyticsEvents.UNIT_VIEW, { unitId, projectId })
  }

  const trackUnitReserve = (unitId, projectId) => {
    trackEvent(AnalyticsEvents.UNIT_RESERVE, { unitId, projectId })
  }

  const trackSearch = (query, resultsCount) => {
    trackEvent(AnalyticsEvents.SEARCH, { query, resultsCount })
  }

  const trackPageView = (page) => {
    trackEvent(AnalyticsEvents.PAGE_VIEW, { page })
  }

  return {
    trackProjectView,
    trackProjectFollow,
    trackProjectUnfollow,
    trackUnitView,
    trackUnitReserve,
    trackSearch,
    trackPageView,
  }
}
